// import React from 'react';
import { useCSVReader } from "react-papaparse";
import "./CsvImpoter.css";
import * as Icons from "heroicons-react";
import { useDispatch } from "react-redux";
import { selectcsvData } from "../../../features/importSlice";

// import { Papa, usePapaParse } from 'react-papaparse';

const styles = {
  csvReader: {
    display: "flex",
    flexDirection: "row",
    marginBottom: 10,
  },
  browseFile: {
    // width: '20%',
  },
  acceptedFile: {
    border: "1px solid #ccc",
    height: 45,
    lineHeight: 2.5,
    paddingLeft: 10,
    // width: '80%',
  },
  remove: {
    borderRadius: 0,
    // padding: '0 20px',
  },
  progressBarBackgroundColor: {
    backgroundColor: "black",
  },
};
//
const CsvImporterGroup = () => {
  const dispatch = useDispatch();
  const { CSVReader } = useCSVReader();

  return (
    <CSVReader
      onUploadAccepted={(results) => {
        const rawData = results?.data || [];
        const cleanedData = rawData
          .map((item) => {
            if (!item || typeof item !== "object") return null;

            // Normalize keys: trim whitespace, strip BOM, and convert to lowercase
            const normalized = {};
            for (const key of Object.keys(item)) {
              const cleanKey = key.trim().replace(/^\ufeff/, "").toLowerCase();
              normalized[cleanKey] =
                typeof item[key] === "string" ? item[key].trim() : item[key];
            }

            const name =
              normalized.name ||
              normalized.group_name ||
              normalized["group name"] ||
              normalized.groupname ||
              normalized.group ||
              normalized.title ||
              "";

            const details =
              normalized.details ||
              normalized.detail ||
              normalized.description ||
              "";

            const status = normalized.status || "active";

            if (!name) return null;

            return {
              ...item,
              name,
              details,
              status,
            };
          })
          .filter(Boolean);

        dispatch(selectcsvData(cleanedData));
      }}
      config={{
        header: true,
        skipEmptyLines: true,
        transformHeader: (header) =>
          header ? header.trim().replace(/^\ufeff/, "") : header,
      }}
    >
      {({ getRootProps, acceptedFile, ProgressBar, getRemoveFileProps }) => {
        const rootProps = getRootProps();
        return (
          <>
            <div className="row mt-3 gx-0 align-items-center">
              <div className="col-12">
                <div className="input-group">
                  <span className="input-group-text">
                    <button
                      type="button"
                      {...rootProps}
                      className="btn btn-dark btn-block"
                      style={{ zIndex: 0 }}
                    >
                      Browse Csv
                    </button>
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    value={acceptedFile ? acceptedFile.name : "No File Selected"}
                    aria-describedby="basic-addon1"
                    readOnly
                    onClick={(e) => {
                      if (rootProps?.onClick) {
                        rootProps.onClick(e);
                      }
                    }}
                    onDrop={(e) => {
                      if (rootProps?.onDrop) {
                        rootProps.onDrop(e);
                      }
                    }}
                    onDragOver={(e) => {
                      if (rootProps?.onDragOver) {
                        rootProps.onDragOver(e);
                      }
                    }}
                    style={{ cursor: "pointer", backgroundColor: "#fff" }}
                    placeholder="Click or Browse to upload CSV"
                  />
                  <span className="input-group-text">
                    <span className="input-group-text" id="basic-addon1">
                      <button
                        {...getRemoveFileProps({
                          onClick: () => {
                            dispatch(selectcsvData([]));
                          },
                        })}
                        className="btn btn-outline-dark btn-block"
                        style={{ zIndex: 0 }}
                      >
                        <Icons.X size="16" />
                      </button>
                    </span>
                  </span>
                </div>
              </div>

              <div className="col-12">
                <ProgressBar />
              </div>
            </div>
          </>
        );
      }}
    </CSVReader>
  );
};

export default CsvImporterGroup;
